import searchDelay from '@/extra-functions/searchDelay.extra'
import { errorHandler } from '@/extra-functions/store.extra'

export default class VueRequestHandler {
  constructor (Vue, { loading = null, data = null, error = null, count = null }, conditions = {}, pagination = false) {
    const { hasLoading = true, hasList = true, hasError = true } = conditions || {}
    this.Vue = Vue
    this.setDelay()
    this.setPaginationMode(pagination)
    if (pagination) this.setDataCountVariable(count)
    if (hasLoading) this.setLoadingVariableName(loading)
    if (hasList) this.setListVariableName(data)
    if (hasError) this.setErrorVariableName(error)
  }

  setDataCountVariable (count) {
    this.dataCountVariable = count
  }

  setPaginationMode (pagination) {
    this.pagination = pagination
  }

  setVue (Vue) {
    this.Vue = Vue
  }

  setDelay () {
    this.delay = searchDelay()
  }

  setListVariableName (name) {
    this.dataVariable = name
  }

  setErrorVariableName (name) {
    this.errorVariable = name
  }

  setLoadingVariableName (name) {
    this.loadingVariable = name
  }

  setLoading (isloading = true) {
    this.Vue[this.loadingVariable] = isloading
  }

  get getLoading () {
    return this.Vue[this.loadingVariable]
  }

  setList (data) {
    if (this.pagination) {
      const { list, count } = data
      this.Vue[this.dataVariable] = list
      this.Vue[this.dataCountVariable] = count
      return
    }
    this.Vue[this.dataVariable] = data
  }

  setErrors (e) {
    this.Vue[this.errorVariable] = errorHandler(e)
  }

  clearErrors () {
    this.Vue[this.errorVariable] = {}
  }

  execute (repository = () => {}, args = [], statusOkCallback = () => {}, statusErrorCallback = () => {}, afterRequestCallback = () => {}) {
    this.setLoading(true)
    this.clearErrors()
    return new Promise((resolve, reject) => {
      this.delay(() => {
        repository(...args)
          .then(response => {
            if (this.dataVariable) this.setList(response.data)
            statusOkCallback(response)
            resolve(response)
          })
          .catch(e => {
            if (this.errorVariable) this.setErrors(e)
            statusErrorCallback(e)
            reject(e)
          })
          .then(() => {
            if (this.loadingVariable) this.setLoading(false)
            afterRequestCallback()
          })
      })
    })
  }
}
